<template>
    <font-awesome-icon :icon="splitIcon" v-bind="$attrs" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
    name: 'AlzataIcon',
    props: {
        icon: String,
    },
    computed: {
        splitIcon() {
            const parts = (this.icon instanceof Array) ? this.icon : this.icon.split('/');
            if (parts.length === 1) {
                parts.splice(0, 0, 'fas');
            }

            if (!library.definitions[parts[0]] || !library.definitions[parts[0]][parts[1]])
            {
                return ['fal', 'question-square'];
            }

            return parts;
        },
    },
};
</script>